import { useEffect } from 'react'

import { useUser } from '@clerk/react'
import { toast } from 'sonner'

import { Progress } from '@/components/ui/progress'
import { Skeleton } from '@/components/ui/skeleton'

import { useCheckOnboardingTasks } from '../hooks/use-check-onboarding-task'
import { useOnboardingProgressPercentage } from '../store'

export const QuickStart = () => {
	useCheckOnboardingTasks()

	const { user, isLoaded } = useUser()

	const progress = useOnboardingProgressPercentage()

	useEffect(() => {
		if (!isLoaded) return

		if (
			progress === 100 &&
			!user?.unsafeMetadata.onboarding_progress?.quickStart.completed
		) {
			toast.success('You have completed the Quick Start guide!')
		}
	}, [progress, user, isLoaded])

	return (
		<div className="border-input my-8 flex flex-col gap-4 rounded-lg border p-4">
			<div>
				<h2 className="text-xl font-semibold">Quick Start</h2>
				<p className="text-muted-foreground text-sm">
					Use our Quick Start guide to learn about everything BitLyft AIR® can
					do for you
				</p>
			</div>

			<Progress value={progress} />
		</div>
	)
}

export const QuickStartSkeleton = () => {
	return (
		<div className="border-input my-8 flex flex-col gap-4 rounded-lg border p-4">
			<div>
				<h2 className="text-xl font-semibold">Quick Start</h2>
				<p className="text-muted-foreground text-sm">
					Use our Quick Start guide to learn about everything BitLyft AIR® can
					do for you
				</p>
			</div>

			<Skeleton className="h-1 w-full" />
		</div>
	)
}
